<template>
    <div
        v-show="breadcrumbs && breadcrumbs.length"
        class="wrapper relative"
        itemprop="http://schema.org/breadcrumb"
        itemscope
        itemtype="http://schema.org/BreadcrumbList"
    >
        <ul
            v-show="!isCrumbsDisabled"
            :class="['crumbs', {'hidden': breadcrumbs && breadcrumbs.length < 2}]"
        >
            <template v-for="(crumb, index) in breadcrumbs">
                <li
                    v-if="crumb.title"
                    :key="`${crumb.slug}_${index}`"
                    class="crumbs__crumb"
                    itemprop="itemListElement"
                    itemscope
                    itemtype="http://schema.org/ListItem"
                >
                    <n-link
                        v-if="!crumb.disabled"
                        :to="crumb.href"
                        class="crumbs__crumb__link"
                        itemprop="name"
                    >
                        {{ crumb.title }}
                    </n-link>
                    <span
                        v-else
                        class="crumbs__crumb__last"
                        itemprop="name"
                    >
                        {{ crumb.title }}
                    </span>
                    <span
                        v-if="!crumb.disabled"
                        class="crumbs__crumb__arrow"
                    >
                        <CheveronSvg style="transform: rotate(-90deg) translateX(2px);" />
                    </span>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import {defineComponent, computed} from 'vue';

import {useNavigationStore} from '@/stores/navigation';

export default defineComponent({
    name: 'TheBreadcrumbs',
    components: {
        CheveronSvg: () => import('@/assets/images/icons/arrows/chevron-small.svg?inline'),
    },
    setup() {
        const navigationStore = useNavigationStore();
        const breadcrumbs = computed(() => navigationStore.breadcrumbs);
        const isCrumbsDisabled = computed(() => navigationStore.hideBreadcrumbs);

        return {
            breadcrumbs,
            isCrumbsDisabled,
        };
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/components/breadcrumbs/breadcrumbs';
</style>
